import { Container, Box, Stack, Alert, AlertTitle } from "@mui/material";
import React, { useState } from "react";
import Header from "../components/common/Header";
import Input from "../components/Base/Input";
import IntroCard from "../components/Cards/IntroCard";
import SubmitButton from "../components/common/SubmitButton";
//import UploadDocument from '../components/common/UploadDocument';
import Note from "../components/common/Note";
import configData from "../Config";
import { useNavigate, useLocation } from "react-router-dom";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import { apis } from "../services/apiService";
import "../Style/Theme/index.css";
import AlertPopup from "../components/common/AlertPopup";

export default function UploadShopCertificate() {
  const navigate = useNavigate();
  let location = useLocation();
  const [disabled, setDisabled] = useState(true);
  const [files, setFiles] = useState();
  const [loading, setLoading] = useState(false);
  const [finalErr, setFinalErr] = useState("");
  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const reqData = {
        formfiles: (() => {
          let data;
          for (const key of Object.keys(files)) data = files[key];
          return data;
        })(),
        filetype: "ShopCert",
        aid: location?.state?.AppId,
      };

      let resp = await apis.postWithFilesApi(
        configData.API_URL + "UploadDocument/UploadShopCer",
        reqData
      );
      let result = await resp.json();
      if (resp?.status === 200) {
        let data = { AppId: location?.state?.AppId };
        navigate("/upload-income-proof", { state: data });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
    }
  };
  const savefile = (e) => {
    if (e.target.files?.length > 0) {
      setFiles(e?.target?.files);
      setDisabled(false);
    } else {
      setFiles(undefined);
      setDisabled(true);
    }
    // setFiles(e.target.files);
    // setDisabled(false);
  };
  const handleClosedFunk = () => {
    setFinalErr("");
  };
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={6} />
        <IntroCard
          title="Shop and establishment certificate"
          subtitle="Upload document to proceed"
          img="/assets/doc.svg"
        />
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: "" }}>
            <Input
              type="file"
              multiple
              autoComplete="off"
              onChange={savefile}
              name="ShopCert"
              id="ShopCertId"
              accept=".zip,application/pdf"
            />
          </Box>
          <Box sx={{ paddingBottom: "55px" }}>
            <Note
              udyamNote="udyamNote"
              note="Only files with .pdf or .zip extension allowed"
            />
          </Box>
          {loading && (
            <Backdrop ax="center">
              <LoadingDots />
            </Backdrop>
          )}
          {finalErr && (
            <Backdrop ax="center">
              <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />
              ;
            </Backdrop>
          )}
          <SubmitButton hasNote="No" disabled={disabled} />
        </form>
      </Container>
    </>
  );
}
